import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

import Avatar from "primevue/avatar"
  import AvatarGroup from "primevue/avatargroup"
  import { IAvatar } from "./OGrupoAvatar.type"
  import { ref, computed, withDefaults, onBeforeMount, watch } from "vue"
  import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import { usarFuncoesStrings } from "@/composable/UsarFuncoesStrings/usarFuncoesStrings"
  import { usarFoto } from "@/composable/UsarFoto/usarFoto"
  import { ResultadoApiGET, estados } from "@/types/api"
  import { Anulavel } from "@/types/gerais"
  import { ListarUsuarios } from "@/repositorios/usuarios/usuarios.modelo"

  interface Props {
    avatares?: IAvatar[]
    requisitarAvataresPorId?: boolean
    identificadores?: string[]
    limitarQuantidadeEm?: Anulavel<number>
    obterFotoDe?: "usuario" | "profissional"
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OGrupoAvatar',
  props: {
    avatares: null,
    requisitarAvataresPorId: { type: Boolean, default: false },
    identificadores: null,
    limitarQuantidadeEm: { default: null },
    obterFotoDe: { default: "usuario" }
  },
  setup(__props: any) {

const props = __props as { avatares?: IAvatar[], requisitarAvataresPorId: boolean, identificadores?: string[], limitarQuantidadeEm: Anulavel<number>, obterFotoDe: "usuario" | "profissional" }

  

  const { obterUrlFotoUsuario, obterUrlFotoProfissional } = usarFoto()
  const { pegarIniciais } = usarFuncoesStrings()

  const estagioDaRequisicao = ref<number>(estados.INICIAL)
  const listaDeAvatares = ref<IAvatar[]>([])

  const estaCarregando = computed(() => {
    return estagioDaRequisicao.value === estados.PEDENTE
  })
  const quantidadeRestanteDaRequisicao = ref<number | null>(null)

  const quantidadeDeAvataresRestante = computed(() => {
    if (quantidadeRestanteDaRequisicao.value) {
      return {
        id: "quantidade_de_avatares_restante",
        nome: `+${quantidadeRestanteDaRequisicao.value}`,
      }
    }

    if (!props.limitarQuantidadeEm) {
      return null
    }
    const quantidadeRestante =
      listaDeAvatares.value.length - props.limitarQuantidadeEm

    if (quantidadeRestante <= 0) {
      return null
    }
    return {
      id: "quantidade_de_avatares_restante",
      nome: `+${quantidadeRestante}`,
    }
  })

  const definirTamanhoDeFonte = (
    quantidadeCaracteres: number
  ): { "font-size": `${number}px` } => {
    const tamanhoDeFonteBase = 16

    const tamanhoDeFonte = tamanhoDeFonteBase - quantidadeCaracteres
    return {
      "font-size": `${tamanhoDeFonte}px`,
    }
  }

  const exibirFotoOuNome = (foto: Anulavel<string>, nome: string) => {
    if (foto) {
      return undefined
    }

    return pegarIniciais(nome)
  }

  const retornarAvataresAteOLimite = (avatares: IAvatar[]): IAvatar[] => {
    const existeLimiteDefinido = !!props.limitarQuantidadeEm
    if (!existeLimiteDefinido) {
      return avatares
    }

    return avatares.slice(0, props.limitarQuantidadeEm!)
  }

  const obterFotosDaListaDeAvatares = async (avatar: ListarUsuarios) => {
    if (!avatar?.urlFotoAvatar) {
      return avatar
    }

    const { urlFotoAvatar } = avatar
    const regexDeUrl = /https?:\/\/(www\.)?[^\/]*?\/?([^$]*?$)?/

    if (regexDeUrl.test(urlFotoAvatar)) {
      return avatar
    }

    if (props.obterFotoDe === "usuario") {
      avatar.urlFotoAvatar = await obterUrlFotoUsuario(urlFotoAvatar)
    } else {
      avatar.urlFotoAvatar = await obterUrlFotoProfissional(urlFotoAvatar)
    }
  }

  const lidarComAvataresAssincronos = async (
    identificadores: Anulavel<string[]>
  ): Promise<ListarUsuarios[]> => {
    const QUANTIDADE_MAXIMA_DE_AVATARES = 30
    if (!identificadores || identificadores?.length === 0) {
      return []
    }

    let listaTemporaria: ResultadoApiGET<ListarUsuarios> | null
    const quantidadePorPagina =
      props.limitarQuantidadeEm || QUANTIDADE_MAXIMA_DE_AVATARES

    estagioDaRequisicao.value = estados.PEDENTE
    const usuarioRepositorio = new UsuariosRepositorio()
    const filtroDeIdentificadores = `em.(${identificadores.join(",")})`

    try {
      listaTemporaria = await usuarioRepositorio.listarUsuarios({
        id: filtroDeIdentificadores,
        "por-pagina": quantidadePorPagina.toString(),
      })

      quantidadeRestanteDaRequisicao.value =
        listaTemporaria.totalDeResultados -
        listaTemporaria.resultadosNessaPagina

      await Promise.all(
        listaTemporaria.resultados.map(obterFotosDaListaDeAvatares)
      )
      estagioDaRequisicao.value = estados.SUCESSO
    } catch (error: any) {
      listaTemporaria = null
      estagioDaRequisicao.value = estados.ERRO
    }

    return listaTemporaria?.resultados || []
  }

  const atualizarAvataresPorProp = (): void => {
    if (!props.requisitarAvataresPorId) {
      listaDeAvatares.value = props.avatares || []
    }
  }

  watch(
    () => props.avatares,
    () => atualizarAvataresPorProp()
  )

  onBeforeMount(async () => {
    if (props.requisitarAvataresPorId) {
      listaDeAvatares.value = await lidarComAvataresAssincronos(
        props.identificadores
      )
    } else {
      listaDeAvatares.value = props.avatares || []
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_unref(estaCarregando))
    ? (_openBlock(), _createBlock(_component_Skeleton, { key: 0 }))
    : (_openBlock(), _createBlock(_unref(AvatarGroup), {
        key: 1,
        class: "OGrupoAvatar",
        "data-testid": "OGrupoAvatar"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(retornarAvataresAteOLimite(listaDeAvatares.value), (avatar) => {
            return (_openBlock(), _createBlock(_unref(Avatar), {
              key: avatar.id,
              class: "OGrupoAvatar__Item",
              "data-testid": "OGrupoAvatar__Item",
              image: avatar?.urlFotoAvatar,
              label: exibirFotoOuNome(avatar?.urlFotoAvatar, avatar.nome),
              shape: "circle",
              title: avatar.nome
            }, null, 8, ["image", "label", "title"]))
          }), 128)),
          (_unref(quantidadeDeAvataresRestante))
            ? (_openBlock(), _createBlock(_unref(Avatar), {
                key: _unref(quantidadeDeAvataresRestante).id,
                class: "OGrupoAvatar__Item",
                "data-testid": "OGrupoAvatar__Item",
                label: _unref(quantidadeDeAvataresRestante).nome,
                shape: "circle",
                style: _normalizeStyle(definirTamanhoDeFonte(_unref(quantidadeDeAvataresRestante).nome.length)),
                title: _unref(quantidadeDeAvataresRestante).nome
              }, null, 8, ["label", "style", "title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
}
}

})